var _defs, _path, _defs2, _path2, _defs3, _path3, _defs4, _path4, _defs5, _path5, _defs6, _path6, _defs7, _path7, _defs8, _path8, _defs9, _defs10, _defs11, _path9, _defs12, _path10, _defs13, _path11, _defs14, _path12, _defs15, _path13, _animateTransform, _animateTransform2, _animateTransform3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: 361022587,
    viewBox: "0 0 155 151",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 361022587,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021265",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,2.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021266",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021266_fill_path",
    d: "M79.96551,0.03407c-39.70604,-1.15628 -74.09984,27.25606 -79.29617,64.5366c-5.6814,40.76124 25.58836,77.43651 64.06453,83.31058c47.8579,7.30642 94.27726,-34.96195 90.10933,-80.81677c-3.14022,-34.54755 -34.51575,-65.85498 -74.87769,-67.0304z",
    fillRule: "nonzero",
    fill: "rgb(242, 249, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.642,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021267",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021268",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021269",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,12.158700000000001,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021270",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021271",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021272",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021272_fill_path",
    d: "M35.73496,129.21644c-1.12178,2.66049 -3.21273,6.35471 -5.43952,10.61023h47.44921c-7.24776,-13.39989 -16.72857,-27.20182 -9.34123,-53.36133c3.46674,-12.27623 14.18296,-34.52853 6.60598,-47.23629c-8.63229,-14.47779 -20.3345,-5.99207 -25.27493,-17.45315c-7.72178,-17.91348 -25.46679,-28.58345 -41.17175,-16.85121c-15.50016,11.57925 -10.09827,44.90459 17.36146,78.24098c16.99078,26.14728 15.66841,32.15871 9.81078,46.05078z",
    fillRule: "nonzero",
    fill: "rgb(214, 232, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021273",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "I361022587357021274_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021274",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021275",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021275_fill_path",
    d: "M35.73496,129.21644c-1.12178,2.66049 -3.21273,6.35471 -5.43952,10.61023h47.44921c-7.24776,-13.39989 -16.72857,-27.20182 -9.34123,-53.36133c3.46674,-12.27623 14.18296,-34.52853 6.60598,-47.23629c-8.63229,-14.47779 -20.3345,-5.99207 -25.27493,-17.45315c-7.72178,-17.91348 -25.46679,-28.58345 -41.17175,-16.85121c-15.50016,11.57925 -10.09827,44.90459 17.36146,78.24098c16.99078,26.14728 15.66841,32.15871 9.81078,46.05078z",
    fillRule: "nonzero",
    fill: "rgb(214, 232, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#I361022587357021274_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.3130000000000006,-10.8567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021276",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021277",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.4198000000000004,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021278",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021278_fill_path",
    d: "M54.71935,147.93413c-0.54814,-6.15218 -1.37703,-11.92702 -2.25466,-18.04103l-0.29224,-2.03844c-0.60399,-2.91801 -1.12033,-5.81158 -1.61963,-8.60986c-1.12744,-6.31854 -2.1924,-12.2869 -4.18879,-18.49758c-0.07456,-0.36889 -0.12884,-0.7297 -0.18609,-1.11197c-0.20485,-1.36491 -0.41682,-2.77622 -1.40512,-4.0118l-0.02636,-0.05348c-8.06943,-33.20884 -23.12431,-65.30938 -44.74646,-95.40944l0.22356,-0.16054c21.63622,30.11973 36.70361,62.24281 44.78329,95.47553c1.01849,1.28809 1.24393,2.79153 1.44312,4.11892c0.05698,0.37881 0.11057,0.73661 0.18011,1.08372c1.99795,6.21321 3.06453,12.1904 4.19369,18.51844c0.49892,2.79644 1.01499,5.68809 1.61978,8.61078l0.29348,2.04685c0.87822,6.11768 1.7076,11.89612 2.25644,18.05575z",
    fillRule: "nonzero",
    fill: "rgb(252, 253, 254)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.848,40.9788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021279",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021279_fill_path",
    d: "M0.65467,77.14269c-2.60415,-15.88065 3.05601,-36.01218 8.26275,-50.10415c5.63871,-15.26086 11.97477,-26.92264 12.03817,-27.03854l0.24161,0.13181c-0.06323,0.1159 -6.39126,11.76296 -12.02302,27.00577c-5.19461,14.05978 -10.84216,34.14022 -8.24793,49.9607z",
    fillRule: "nonzero",
    fill: "rgb(252, 253, 254)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,26.032099999999996,7.2334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021280",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021280_fill_path",
    d: "M3.75521,43.23116c-3.70243,-16.69774 -3.72119,-35.07908 -3.72734,-41.1193c-0.00124,-1.15531 -0.00205,-1.9186 -0.02787,-2.06324l0.27089,-0.04863c0.02906,0.16178 0.03072,0.76426 0.03218,2.1117c0.00615,6.03283 0.02491,24.39148 3.72087,41.05989z",
    fillRule: "nonzero",
    fill: "rgb(252, 253, 254)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,53.926500000000004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021281",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021281_fill_path",
    d: "M39.76727,22.65084c-7.80189,-13.71774 -39.44857,-22.29984 -39.76727,-22.38496l0.07095,-0.26588c0.31978,0.08528 32.07735,8.69817 39.93557,22.51494z",
    fillRule: "nonzero",
    fill: "rgb(252, 253, 254)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  })))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,38.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021282",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021283",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021284",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021284_fill_path",
    d: "M39.7383,37.90601c0.25558,21.79941 10.76992,14.61633 20.46523,16.76776c11.18949,16.18976 12.24361,31.21046 -4.46296,44.18237l-18.61536,-2.78582c-6.90706,-0.32054 -15.01175,-2.4316 -14.55445,-11.62874c0.5172,-10.40189 2.97709,-17.00846 -8.76366,-22.11676c-11.74059,-5.10836 -16.78415,-14.42949 -12.02976,-25.03186c5.00323,-11.15736 -6.73213,-26.19698 1.84431,-33.67256c14.94393,-13.02577 35.85045,11.58583 36.11665,34.28561z",
    fillRule: "nonzero",
    fill: "rgb(187, 216, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021285",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "I361022587357021286_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021286",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021287",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021287_fill_path",
    d: "M39.7383,37.90601c0.25558,21.79941 10.76992,14.61633 20.46523,16.76776c11.18949,16.18976 12.24361,31.21046 -4.46296,44.18237l-18.61536,-2.78582c-6.90706,-0.32054 -15.01175,-2.4316 -14.55445,-11.62874c0.5172,-10.40189 2.97709,-17.00846 -8.76366,-22.11676c-11.74059,-5.10836 -16.78415,-14.42949 -12.02976,-25.03186c5.00323,-11.15736 -6.73213,-26.19698 1.84431,-33.67256c14.94393,-13.02577 35.85045,11.58583 36.11665,34.28561z",
    fillRule: "nonzero",
    fill: "rgb(187, 216, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#I361022587357021286_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2.3236,-2.3994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021288",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021289",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.7188,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021290",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021290_fill_path",
    d: "M35.96475,79.31704c-7.77202,-8.50275 -14.50577,-17.95122 -20.01429,-28.08319c-5.55579,-10.21941 -9.79073,-20.99833 -12.58663,-32.03768c-1.60323,-6.33008 -2.73504,-12.7794 -3.36383,-19.16873l0.28011,-0.02744c0.62765,6.37509 1.75687,12.8104 3.35671,19.12712c2.79008,11.01644 7.01628,21.77343 12.56113,31.97219c5.49752,10.11191 12.21812,19.54188 19.97461,28.0277z",
    fillRule: "nonzero",
    fill: "rgb(252, 253, 254)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,26.5196,86.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021291",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021291_fill_path",
    d: "M0.12776,5.21903l-0.12776,-0.251c3.45741,-1.76124 7.53579,-3.13471 12.12194,-4.08225c2.18534,-0.45159 4.35623,-0.7496 6.4524,-0.88578l0.01839,0.28108c-2.08323,0.1352 -4.24119,0.43143 -6.41364,0.88059c-4.56183,0.94232 -8.61633,2.30743 -12.05132,4.05735z",
    fillRule: "nonzero",
    fill: "rgb(252, 253, 254)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,48.71040000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021292",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021292_fill_path",
    d: "M30.2931,8.74335c-9.61261,-9.2986 -30.07482,-8.44885 -30.27989,-8.43785l-0.01321,-0.2814c0.20733,-0.009 20.78857,-0.86691 30.48895,8.51692z",
    fillRule: "nonzero",
    fill: "rgb(252, 253, 254)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,17.9645,1.0373000000000019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021293",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021293_fill_path",
    d: "M0.47542,32.14846c-2.87725,-14.83439 8.2407,-31.97714 8.35326,-32.14846l0.23526,0.15456c-0.11197,0.17057 -11.16728,17.21935 -8.31202,31.94038z",
    fillRule: "nonzero",
    fill: "rgb(252, 253, 254)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  })))))))))))))))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,28.9541,56.7612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021294",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,75.77359999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021295",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,1.7151000000000067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021296",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36an55728935175219771",
    x1: -58.622092420817665,
    y1: -0.12438185242966629,
    x2: 16.380910438530382,
    y2: 17.13265648793426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(125, 188, 255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(71, 135, 254)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021296_fill_path",
    d: "M105.25548,4.52242l-65.40421,-4.51665c-0.07865,-0.00744 -0.15785,-0.00766 -0.23655,-0.00076l-38.95073,1.76459c-0.93175,0.08469 -0.88938,2.52436 0.16819,2.65751l61.20151,8.19494c0.25051,0.03094 0.50395,0.03019 0.7543,-0.00216l42.34705,-5.95036c0.56512,-0.09838 0.7716,-2.09945 0.12044,-2.14711z",
    fillRule: "nonzero",
    fill: "url(#ldd36an55728935175219771)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.3096999999999994,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021297",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36ani8585831872264797",
    x1: -58.28198724661221,
    y1: -0.11968483830239036,
    x2: 16.285874042382197,
    y2: 16.48567842811563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(125, 188, 255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(71, 135, 254)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021297_fill_path",
    d: "M104.81665,6.1655l-65.2751,-6.15974c-0.07865,-0.00744 -0.15784,-0.00765 -0.23655,-0.00075l-38.76167,3.40307c-0.71175,0.06248 -0.72992,1.0965 -0.02086,1.184l61.20151,7.5525c0.25051,0.03089 0.50393,0.03019 0.75428,-0.00216l42.34707,-5.47283c0.3,-0.03876 0.29246,-0.47562 -0.00867,-0.50409z",
    fillRule: "nonzero",
    fill: "url(#ldd36ani8585831872264797)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021297_fill_path",
    d: "M104.81665,6.1655l-65.2751,-6.15974c-0.07865,-0.00744 -0.15784,-0.00765 -0.23655,-0.00075l-38.76167,3.40307c-0.71175,0.06248 -0.72992,1.0965 -0.02086,1.184l61.20151,7.5525c0.25051,0.03089 0.50393,0.03019 0.75428,-0.00216l42.34707,-5.47283c0.3,-0.03876 0.29246,-0.47562 -0.00867,-0.50409z",
    fillRule: "nonzero",
    fill: "rgb(0, 0, 0)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.067499999999999,0.761400000000009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021298",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36anv4172405454302759",
    x1: 0.01246934278460097,
    y1: 10.646319474945432,
    x2: 95.64958057726643,
    y2: 10.646319474945432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(218, 227, 254)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(233, 239, 253)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021298_fill_path",
    d: "M57.31903,10.64561c0.09051,0 0.18199,-0.00587 0.27181,-0.01746l37.95482,-4.90519c0.13833,-0.0179 0.13483,-0.21929 -0.00399,-0.23239l-58.28421,-5.48874c-0.01305,-0.00124 -0.02615,-0.00183 -0.03903,-0.00183c-0.01202,0 -0.02399,0.00054 -0.03596,0.00157l-37.05121,3.25287c-0.17197,0.01509 -0.17633,0.26491 -0.00507,0.28605l56.93309,7.08916c0.08582,0.01057 0.17321,0.01596 0.25974,0.01596z",
    fillRule: "nonzero",
    fill: "url(#ldd36anv4172405454302759)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,82.9788,8.727800000000002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021299",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36ao69855998977971732",
    x1: 1.5454047994679314,
    y1: 0.13156649576233748,
    x2: 0.00040392982001630863,
    y2: 0.31942017741513035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(255, 144, 133)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(251, 111, 187)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021299_fill_path",
    d: "M0.00041,0.31941c0.01375,0.11321 0.37078,0.16291 0.79741,0.11105c0.42668,-0.05186 0.76134,-0.18566 0.7476,-0.29886c-0.0138,-0.11321 -0.37078,-0.16291 -0.79746,-0.11105c-0.42658,0.05186 -0.76129,0.18566 -0.74754,0.29886z",
    fillRule: "nonzero",
    fill: "url(#ldd36ao69855998977971732)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,37.1707,9.795299999999997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021300",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.288700000000006,1.6941000000000201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021301",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36aoi5799557079969984",
    x1: -4.055795813962959,
    y1: -0.018033583245099304,
    x2: 1.1333206516849024,
    y2: 2.4839892713413425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(125, 188, 255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(71, 135, 254)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021301_fill_path",
    d: "M0.65455,1.05235l5.87493,0.77181c0.42922,0.05639 0.78065,-0.15343 0.78065,-0.46917c0,-0.31574 -0.35143,-0.61277 -0.78065,-0.66296l-5.87493,-0.68632c-0.36296,-0.04243 -0.65455,0.1557 -0.65455,0.44211c0.00005,0.28642 0.29159,0.55687 0.65455,0.60452z",
    fillRule: "nonzero",
    fill: "url(#ldd36aoi5799557079969984)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021301_fill_path",
    d: "M0.65455,1.05235l5.87493,0.77181c0.42922,0.05639 0.78065,-0.15343 0.78065,-0.46917c0,-0.31574 -0.35143,-0.61277 -0.78065,-0.66296l-5.87493,-0.68632c-0.36296,-0.04243 -0.65455,0.1557 -0.65455,0.44211c0.00005,0.28642 0.29159,0.55687 0.65455,0.60452z",
    fillRule: "nonzero",
    fill: "rgb(0, 0, 0)",
    fillOpacity: 0.31,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.982800000000012,0.9458000000000197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021302",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36aov4272225285551312",
    x1: -3.3395221110278173,
    y1: -0.015737702413044445,
    x2: 0.9331705906289375,
    y2: 2.1677491055577454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(125, 188, 255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(71, 135, 254)"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021302_fill_path",
    d: "M0.54339,0.95753l4.83806,0.63558c0.35073,0.04609 0.63763,-0.14745 0.63763,-0.43268c0,-0.28523 -0.2869,-0.54997 -0.63763,-0.59094l-4.83806,-0.56517c-0.30124,-0.0352 -0.54339,0.14813 -0.54339,0.40916c0.00005,0.26102 0.24221,0.50448 0.54339,0.54405z",
    fillRule: "nonzero",
    fill: "url(#ldd36aov4272225285551312)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021302_fill_path",
    d: "M0.54339,0.95753l4.83806,0.63558c0.35073,0.04609 0.63763,-0.14745 0.63763,-0.43268c0,-0.28523 -0.2869,-0.54997 -0.63763,-0.59094l-4.83806,-0.56517c-0.30124,-0.0352 -0.54339,0.14813 -0.54339,0.40916c0.00005,0.26102 0.24221,0.50448 0.54339,0.54405z",
    fillRule: "nonzero",
    fill: "rgb(0, 0, 0)",
    fillOpacity: 0.31,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021303",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36ap97303112631863993",
    x1: -2.540247210603057,
    y1: -0.01304441975744624,
    x2: 0.7098273079355037,
    y2: 1.796769853665933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(125, 188, 255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(71, 135, 254)"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021303_fill_path",
    d: "M0.41763,0.83811l3.68075,0.48356c0.2642,0.03472 0.48011,-0.13746 0.48011,-0.38479c0,-0.24739 -0.2159,-0.47311 -0.48011,-0.504l-3.68075,-0.42996c-0.23137,-0.02701 -0.41763,0.13681 -0.41763,0.36582c0,0.22895 0.1862,0.43903 0.41763,0.46938z",
    fillRule: "nonzero",
    fill: "url(#ldd36ap97303112631863993)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021303_fill_path",
    d: "M0.41763,0.83811l3.68075,0.48356c0.2642,0.03472 0.48011,-0.13746 0.48011,-0.38479c0,-0.24739 -0.2159,-0.47311 -0.48011,-0.504l-3.68075,-0.42996c-0.23137,-0.02701 -0.41763,0.13681 -0.41763,0.36582c0,0.22895 0.1862,0.43903 0.41763,0.46938z",
    fillRule: "nonzero",
    fill: "rgb(0, 0, 0)",
    fillOpacity: 0.31,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.231599999999997,3.2608000000000175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021304",
    opacity: 0.6000000238418579,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021304_fill_path",
    d: "M20.54464,0.54524c5.68787,1.01267 9.46544,3.07461 17.62781,3.23967c7.07067,0.14302 7.12308,-1.4863 15.34092,-2.00097c10.76609,-0.67429 13.57228,1.9407 24.5836,1.71514c2.87132,-0.05881 6.62965,-0.31801 11.07634,-1.13429l5.72146,0.5399c0.30113,0.02846 0.30867,0.46527 0.00867,0.50409l-42.34706,5.47283c-0.25035,0.03235 -0.50377,0.0331 -0.75428,0.00216l-51.8021,-6.39261c8.88863,-2.96372 15.69472,-2.80943 20.54464,-1.94593z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3.0534,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021305",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,33.66439999999999,78.63390000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021306",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021306_fill_path",
    d: "M7.54027,3.93886c-3.03094,0 -7.54027,-0.52447 -7.54027,-1.96943c0,-1.44496 4.50928,-1.96943 7.54027,-1.96943c3.03089,0 7.54016,0.52447 7.54016,1.96943c0,1.44496 -4.50927,1.96943 -7.54016,1.96943zM7.54027,0.5753c-4.57283,0 -6.96496,0.90761 -6.96496,1.39413c0,0.48652 2.39213,1.39413 6.96496,1.39413c4.57278,0 6.96485,-0.90761 6.96485,-1.39413c0.00005,-0.48652 -2.39208,-1.39413 -6.96485,-1.39413z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,37.9081,79.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021307",
    opacity: 0.6000000238418579,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021307_fill_path",
    d: "M6.5932,0.76442c0,0.42218 -1.47594,0.76442 -3.2966,0.76442c-1.82066,0 -3.2966,-0.34224 -3.2966,-0.76442c0,-0.42218 1.47594,-0.76442 3.2966,-0.76442c1.82066,0 3.2966,0.34224 3.2966,0.76442z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021308",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "I361022587357021309_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021309",
    opacity: 0.5600000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021310",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021311",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36aqg02612464007430293",
    x1: 46.52009698429463,
    y1: 76.91894623414541,
    x2: 43.77339666514997,
    y2: 11.913521094077426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(0, 0, 0)"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021311_fill_path",
    d: "M87.74652,13.13088l-39.00566,63.77574l-0.35633,0.58183l-0.47304,0.77424l-0.82944,1.35607l-0.60232,0.98388c0,0.65596 -2.21703,1.18889 -5.00323,1.22205c-0.08987,0.00162 -0.17978,0.00162 -0.27127,0.00162c-2.91396,0 -5.2744,-0.54717 -5.2744,-1.22366l-0.55186,-1.00129l-1.10539,-2.00415l-0.37682,-0.68432l-0.47305,-0.8578l-2.32108,-4.21164l-3.99876,-7.25181l-4.50501,-8.17255l-0.44932,-0.81682l-4.97806,-9.03197l-3.16463,-5.73967l-14.00685,-25.40863c3.24194,-2.4835 10.80749,-7.86043 21.83569,-11.55962c1.63833,-0.55035 3.35229,-1.0628 5.142,-1.52323c0.41315,-0.10728 0.831,-0.21127 1.25359,-0.31218c0.31693,-0.07569 0.63542,-0.14981 0.95558,-0.22075c0.25224,-0.05838 0.50771,-0.11359 0.76313,-0.16873c0.00156,0 0.00156,0 0.00318,0c3.81429,-0.81677 7.92982,-1.38286 12.32124,-1.5689c0.52819,-0.02361 1.06118,-0.04102 1.59881,-0.05202c8.3855,-0.1766 15.85488,1.07849 22.20475,2.91709c0.21439,0.05989 0.42733,0.12297 0.63703,0.18609c0.06146,0.01887 0.12297,0.03628 0.18297,0.05515c0.67639,0.2034 1.34026,0.41477 1.98986,0.63073c1.77709,0.58976 3.45322,1.21887 5.02373,1.86539c6.62582,2.72625 11.3704,5.76641 13.83498,7.45989z",
    fillRule: "nonzero",
    fill: "url(#ldd36aqg02612464007430293)"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#I361022587357021309_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021312",
    opacity: 0.8600000143051147,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021312_fill_path",
    d: "M87.74652,13.13088l-39.00566,63.77574l-0.35633,0.58183l-0.47304,0.77424l-0.82944,1.35607l-0.60232,0.98388c0,0.65596 -2.21703,1.18889 -5.00323,1.22205c-0.08987,0.00162 -0.17978,0.00162 -0.27127,0.00162c-2.91396,0 -5.2744,-0.54717 -5.2744,-1.22366l-0.55186,-1.00129l-1.10539,-2.00415l-0.37682,-0.68432l-0.47305,-0.8578l-2.32108,-4.21164l-3.99876,-7.25181l-4.50501,-8.17255l-0.44932,-0.81682l-4.97806,-9.03197l-3.16463,-5.73967l-14.00685,-25.40863c3.24194,-2.4835 10.80749,-7.86043 21.83569,-11.55962c1.63833,-0.55035 3.35229,-1.0628 5.142,-1.52323c0.41315,-0.10728 0.831,-0.21127 1.25359,-0.31218c0.31693,-0.07569 0.63542,-0.14981 0.95558,-0.22075c0.25224,-0.05838 0.50771,-0.11359 0.76313,-0.16873c0.00156,0 0.00156,0 0.00318,0c3.81429,-0.81677 7.92982,-1.38286 12.32124,-1.5689c0.52819,-0.02361 1.06118,-0.04102 1.59881,-0.05202c8.3855,-0.1766 15.85488,1.07849 22.20475,2.91709c0.21439,0.05989 0.42733,0.12297 0.63703,0.18609c0.06146,0.01887 0.12297,0.03628 0.18297,0.05515c0.67639,0.2034 1.34026,0.41477 1.98986,0.63073c1.77709,0.58976 3.45322,1.21887 5.02373,1.86539c6.62582,2.72625 11.3704,5.76641 13.83498,7.45989z",
    fillRule: "nonzero",
    fill: "rgb(132, 188, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,73.9998,7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021313",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021314",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587360521849",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "I361022587360521849_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,78v-78h78v78z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I361022587360521849_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4,4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021328",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021328_fill_path",
    d: "M69.24012,37.01614l-3.86657,-0.71908c0.21299,-2.60296 0.05918,-5.16878 -0.4219,-7.64258l3.62394,-1.28145c0.9904,-0.35024 1.5151,-1.46103 1.17413,-2.48346l-0.90982,-2.72717c-0.34313,-1.02868 -1.42916,-1.58668 -2.42786,-1.24393l-3.57143,1.22561c-1.10701,-2.38668 -2.54356,-4.62086 -4.26771,-6.63434l2.45494,-2.83984c0.70442,-0.81488 0.61444,-2.07817 -0.202,-2.82491l-2.18291,-1.99655c-0.82528,-0.75477 -2.07509,-0.70588 -2.7904,0.11251l-2.45306,2.80652c-2.18167,-1.56221 -4.61423,-2.85046 -7.25821,-3.79283l0.70259,-3.74237c0.20728,-1.10404 -0.52523,-2.211 -1.63957,-2.47326l-2.98242,-0.70205c-1.12863,-0.26561 -2.21639,0.42313 -2.42588,1.5393l-0.7103,3.78345c-2.85272,-0.29332 -5.67897,-0.17035 -8.40776,0.32868l-1.36588,-3.79741c-0.40135,-1.1159 -1.63881,-1.75175 -2.76641,-1.41736l-3.01575,0.89423c-1.14043,0.33817 -1.73325,1.52647 -1.32161,2.65138l1.42361,3.88997c-2.57941,1.18221 -4.97687,2.72701 -7.11143,4.5883l-3.36361,-2.83536c-0.95364,-0.80388 -2.38161,-0.74798 -3.18803,0.12852l-2.15175,2.33876c-0.81181,0.88243 -0.6848,2.24911 0.28231,3.0489l3.48955,2.88566c-1.54652,2.28356 -2.77628,4.81181 -3.61672,7.53892l-4.6725,-0.86889c-1.25752,-0.23385 -2.45892,0.5269 -2.67914,1.69994l-0.58571,3.11962c-0.22016,1.17305 0.62615,2.30324 1.8862,2.52356l4.80625,0.84054c-0.10609,2.79747 0.20706,5.53843 0.89175,8.15709l-4.68329,1.60717c-1.19418,0.40981 -1.80922,1.64259 -1.37105,2.75051l1.1614,2.9366c0.43526,1.10054 1.74932,1.65111 2.93245,1.23273l4.74679,-1.67855c1.33067,2.34377 2.98626,4.49456 4.91602,6.38814l-3.25386,3.72265c-0.79326,0.90755 -0.67083,2.2249 0.27213,2.93892l2.49337,1.88814c0.93229,0.70598 2.31951,0.54378 3.09989,-0.35892l3.23687,-3.74448c2.25687,1.30609 4.7131,2.32728 7.32572,3.011l-0.87984,4.68653c-0.20949,1.11617 0.55677,2.1394 1.70793,2.28506l3.04194,0.38496c1.1366,0.14383 2.22318,-0.63498 2.4304,-1.73897l0.87025,-4.63558c2.65213,0.04329 5.24026,-0.26663 7.71158,-0.88501l1.55387,4.24588c0.37127,1.01439 1.52139,1.49628 2.56673,1.07903l2.76501,-1.10388c1.03412,-0.41288 1.57698,-1.56199 1.21466,-2.56927l-1.49951,-4.16901c2.26641,-1.19094 4.36222,-2.66749 6.23181,-4.38469l3.29482,2.72464c0.80884,0.66884 2.02642,0.52647 2.7206,-0.31499l1.8406,-2.23105c0.69008,-0.83633 0.60312,-2.05747 -0.19521,-2.73041l-3.17795,-2.67881c1.38695,-2.07784 2.51223,-4.35569 3.32242,-6.79634l3.97872,0.69585c1.02555,0.17935 2.01482,-0.52965 2.21261,-1.58313l0.52592,-2.80162c0.19779,-1.05353 -0.46911,-2.06135 -1.49272,-2.2517zM33.61699,54.20407c-11.5173,-1.72291 -19.42257,-12.39542 -17.28489,-23.78216c2.13774,-11.38663 13.39854,-18.58754 24.78393,-16.16205c10.99854,2.34302 18.01628,12.8552 16.00824,23.55083c-2.00792,10.69558 -12.3813,18.05768 -23.50728,16.39337z",
    fillRule: "nonzero",
    fill: "rgb(187, 216, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,95,90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021329",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021330",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587360521850",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "I361022587360521850_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,44v-44h44v44z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I361022587360521850_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3,4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021344",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021344_fill_path",
    d: "M36.91502,19.73474l-2.06145,-0.38335c0.11358,-1.38771 0.03159,-2.75569 -0.22496,-4.07456l1.93208,-0.68317c0.52803,-0.18674 0.80777,-0.77892 0.62599,-1.32405l-0.48507,-1.45396c-0.18291,-0.54841 -0.76194,-0.84593 -1.29439,-0.66318l-1.9041,0.65342c-0.59019,-1.27245 -1.35607,-2.46362 -2.27531,-3.53704l1.30884,-1.51407c0.37558,-0.43445 0.3276,-1.10798 -0.10766,-1.50609l-1.16382,-1.06441c-0.44,-0.40243 -1.10632,-0.37635 -1.48772,0.05999l-1.30782,1.49629c-1.16313,-0.83288 -2.46005,-1.51968 -3.86965,-2.0221l0.37456,-1.9952c0.11051,-0.58863 -0.27999,-1.17876 -0.87412,-1.3186l-1.59009,-0.37429c-0.60173,-0.14162 -1.18167,0.22556 -1.29337,0.82065l-0.37871,2.01709c-1.52092,-0.15639 -3.0277,-0.09078 -4.48253,0.1752l-0.7282,-2.02459c-0.21396,-0.59493 -0.87374,-0.9339 -1.47493,-0.75568l-1.60783,0.47677c-0.60803,0.18032 -0.92409,0.8138 -0.70463,1.41353l0.75897,2.07391c-1.3752,0.6303 -2.65337,1.45385 -3.79138,2.4462l-1.79326,-1.51165c-0.50841,-0.42857 -1.26976,-0.39881 -1.69968,0.06852l-1.14722,1.24691c-0.43283,0.47046 -0.36507,1.19909 0.15051,1.6255l1.86043,1.53843c-0.82453,1.21747 -1.48015,2.5654 -1.92824,4.01936l-2.49112,-0.46324c-0.67046,-0.12469 -1.31094,0.28092 -1.42835,0.90631l-0.31224,1.66318c-0.11741,0.62539 0.33386,1.22792 1.00561,1.34545l2.56242,0.44814c-0.05655,1.49148 0.1104,2.95277 0.47541,4.34889l-2.49682,0.85687c-0.63671,0.21849 -0.96459,0.87575 -0.731,1.46642l0.6192,1.56561c0.23208,0.58674 0.93267,0.88027 1.5634,0.65719l2.53073,-0.89494c0.70943,1.2496 1.59207,2.39622 2.62091,3.40577l-1.73477,1.9847c-0.42291,0.48383 -0.35763,1.1862 0.14512,1.56684l1.32932,1.00662c0.49704,0.37639 1.23666,0.28993 1.65267,-0.19136l1.72573,-1.99633c1.20323,0.69633 2.51277,1.24075 3.90566,1.60527l-0.46912,2.4986c-0.1117,0.59509 0.29683,1.14064 0.91057,1.21827l1.62178,0.20524c0.60598,0.07666 1.18529,-0.33854 1.29575,-0.92712l0.46399,-2.47143c1.41396,0.02307 2.79379,-0.14217 4.11137,-0.47182l0.82842,2.26366c0.19795,0.54081 0.81116,0.79774 1.36846,0.57526l1.47412,-0.58852c0.55132,-0.22011 0.84075,-0.83277 0.6476,-1.36975l-0.79947,-2.22264c1.20836,-0.63493 2.32572,-1.42216 3.32243,-2.33768l1.7566,1.4526c0.43121,0.3566 1.08038,0.2807 1.45046,-0.16792l0.98129,-1.18948c0.36787,-0.44588 0.32151,-1.09692 -0.10404,-1.45568l-1.69434,-1.42819c0.73946,-1.10776 1.3394,-2.32222 1.77132,-3.6234l2.12125,0.371c0.54679,0.09563 1.07417,-0.28237 1.17961,-0.84404l0.28044,-1.49364c0.10561,-0.56167 -0.24992,-1.09898 -0.79564,-1.20049zM17.92279,28.89834c-6.14038,-0.91854 -10.35504,-6.60851 -9.21537,-12.67924c1.13973,-6.07067 7.14334,-9.9098 13.21336,-8.61665c5.86377,1.24916 9.60523,6.85363 8.53472,12.55595c-1.07051,5.70221 -6.60097,9.62727 -12.53272,8.73994z",
    fillRule: "nonzero",
    fill: "rgb(187, 216, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,25.3813,26.3431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587360522091",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021345",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,77.1151,18.9043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021346",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021346_fill_path",
    d: "M18.9047,13.2834c0,7.33622 -4.23196,13.2834 -9.45235,13.2834c-5.22039,0 -9.45235,-5.94718 -9.45235,-13.2834c0,-7.33622 4.23196,-13.2834 9.45235,-13.2834c5.22039,0 9.45235,5.94719 9.45235,13.2834z",
    fillRule: "nonzero",
    fill: "rgb(216, 222, 232)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.857800000000001,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021347",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021347_fill_path",
    d: "M50.82022,0h-17.79057c-18.24173,0 -33.02965,14.78787 -33.02965,33.02965v0.00027c0,9.73396 7.89094,17.62485 17.62491,17.62485h48.60017c9.73402,0 17.62495,-7.89094 17.62495,-17.62496c-0.00005,-18.24178 -14.78798,-33.02981 -33.02981,-33.02981z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,21.583000000000002,53.9086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021348",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021348_fill_path",
    d: "M32.97062,32.86334h-11.54199c-11.83472,0 -21.42862,-9.59396 -21.42862,-21.42868v-0.00016c0,-6.31509 5.11941,-11.43451 11.4345,-11.43451h31.53035c6.31509,0 11.43455,5.11947 11.43455,11.43456c-0.00005,11.83477 -9.59401,21.42878 -21.42878,21.42878z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,31.666100000000004,21.4551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021349",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021350",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36a7g836993298412992",
    x1: -0.000026954198705517982,
    y1: 11.03766973731769,
    x2: 49.533987808088064,
    y2: 11.03766973731769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(68, 75, 140)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.6399998664856%",
    stopOpacity: 1,
    stopColor: "rgb(38, 38, 79)"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021350_fill_path",
    d: "M42.16027,22.07539h-33.81741c-4.58291,0 -8.34286,-3.51283 -8.34286,-7.84609v-6.6448c0,-4.33326 3.75995,-7.72615 8.34286,-7.57995l33.81741,1.07882c4.09294,0.13057 7.37369,3.49956 7.37369,7.5263v6.17478c0,4.02663 -3.28081,7.29094 -7.37369,7.29094z",
    fillRule: "nonzero",
    fill: "url(#ldd36a7g836993298412992)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,8.033099999999997,5.1571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021351",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021352",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021353",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021353_fill_path",
    d: "M11.14469,5.39713c0,2.89391 -2.46351,5.20874 -5.52712,5.17003c-3.09121,-0.03903 -5.61757,-2.45531 -5.61757,-5.39655c0,-2.94129 2.52641,-5.25488 5.61757,-5.16825c3.06361,0.08588 5.52712,2.50086 5.52712,5.39477z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,23.595200000000006,0.6509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021354",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021354_fill_path",
    d: "M10.40334,5.21069c0,2.79677 -2.30059,5.03493 -5.16086,4.99881c-2.88512,-0.03644 -5.24248,-2.36927 -5.24248,-5.21024c0,-2.84097 2.35736,-5.07795 5.24248,-4.99714c2.86027,0.08016 5.16086,2.41186 5.16086,5.20857z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.857699999999998,1.2913999999999994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021355",
    opacity: 0.30000001192092896,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021355_fill_path",
    d: "M54.19714,44.73063c-5.02943,-5.90933 -2.7945,-10.63531 -9.36976,-18.64329c-9.04706,-11.01871 -19.60119,-9.77187 -22.01865,-17.24513c-0.66987,-2.07084 -0.74679,-4.91315 1.04992,-8.84221c-13.77973,3.97472 -23.85865,16.67892 -23.85865,31.73838v0.00027c0,9.73396 7.89089,17.62485 17.6248,17.62485h42.35439c-2.53687,-1.38296 -4.39084,-2.99827 -5.78205,-4.63288z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2.1585,18.811999999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021356",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021356_fill_path",
    d: "M18.90469,13.28334c0,7.33619 -4.23196,13.28334 -9.45234,13.28334c-5.22039,0 -9.45235,-5.94716 -9.45235,-13.28334c0,-7.33619 4.23196,-13.28334 9.45235,-13.28334c5.22039,0 9.45234,5.94716 9.45234,13.28334z",
    fillRule: "nonzero",
    fill: "rgb(216, 222, 232)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.00009999999999976694,26.286700000000003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021357",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021357_fill_path",
    d: "M8.26674,5.80863c0,3.20802 -1.85057,5.80863 -4.13337,5.80863c-2.2828,0 -4.13337,-2.60061 -4.13337,-5.80863c0,-3.20802 1.85057,-5.80863 4.13337,-5.80863c2.2828,0 4.13337,2.60061 4.13337,5.80863z",
    fillRule: "nonzero",
    fill: "rgb(191, 200, 214)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,21.583000000000002,53.9086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021358",
    opacity: 0.4000000059604645,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021358_fill_path",
    d: "M35.81315,21.06641c-1.58345,-7.43671 -19.0993,-7.2573 -19.57558,-12.11817c-0.36722,-3.74722 9.68933,-7.45714 10.95305,-7.92339c1.08075,-0.39871 2.15347,-0.73612 3.21552,-1.02486h-18.97164c-6.31504,0 -11.4345,5.11941 -11.4345,11.43451v0.00016c0,11.83472 9.59385,21.42868 21.42862,21.42868h11.54205c1.109,0 2.19822,-0.08425 3.26183,-0.24673c-1.00442,-1.24496 -1.65929,-2.60664 -1.81768,-4.09289c-0.35111,-3.29434 2.01191,-4.57558 1.39833,-7.45731z",
    fillRule: "nonzero",
    fill: "rgb(216, 222, 232)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,30.838600000000003,52.3383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021359",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021359_fill_path",
    d: "M36.45725,2.207c0,1.2189 -8.16123,2.20701 -18.22862,2.20701c-10.06739,0 -18.22862,-0.98811 -18.22862,-2.20701c0,-1.2189 8.16123,-2.207 18.22862,-2.207c10.06739,0 18.22862,0.98811 18.22862,2.207z",
    fillRule: "nonzero",
    fill: "rgb(216, 222, 232)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,57.379000000000005,42.0644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021360",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021361",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36aac8076582060214563",
    x1: -32.644992372006364,
    y1: -0.3486404230609994,
    x2: 9.122067709108991,
    y2: 48.02257314417939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(125, 188, 255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(71, 135, 254)"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021361_fill_path",
    d: "M52.51431,10.65685c-3.11234,-1.19353 -6.51553,-0.59256 -9.25763,1.30981c-1.00189,-5.00868 -4.18539,-9.24776 -8.92593,-11.06571c-7.76771,-2.97887 -16.77387,1.67072 -20.11581,10.38512c-0.86119,2.24561 -1.26102,4.54184 -1.24895,6.76469c-0.40038,-0.251 -0.82862,-0.46637 -1.28328,-0.64076c-4.24399,-1.62755 -9.16458,0.91283 -10.99046,5.67402c-1.82588,4.76119 0.07181,10.11396 4.37833,11.56782c2.30011,0.77655 5.93946,0.79106 5.93946,0.79106c0,0 35.40006,-2.63613 36.49197,-2.62707c4.3607,0.03633 8.65853,-2.94668 10.48317,-7.70463c2.28151,-5.94922 -0.16786,-12.4207 -5.47088,-14.45434z",
    fillRule: "nonzero",
    fill: "url(#ldd36aac8076582060214563)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021361_fill_path",
    d: "M52.51431,10.65685c-3.11234,-1.19353 -6.51553,-0.59256 -9.25763,1.30981c-1.00189,-5.00868 -4.18539,-9.24776 -8.92593,-11.06571c-7.76771,-2.97887 -16.77387,1.67072 -20.11581,10.38512c-0.86119,2.24561 -1.26102,4.54184 -1.24895,6.76469c-0.40038,-0.251 -0.82862,-0.46637 -1.28328,-0.64076c-4.24399,-1.62755 -9.16458,0.91283 -10.99046,5.67402c-1.82588,4.76119 0.07181,10.11396 4.37833,11.56782c2.30011,0.77655 5.93946,0.79106 5.93946,0.79106c0,0 35.40006,-2.63613 36.49197,-2.62707c4.3607,0.03633 8.65853,-2.94668 10.48317,-7.70463c2.28151,-5.94922 -0.16786,-12.4207 -5.47088,-14.45434z",
    fillRule: "nonzero",
    fill: "rgb(0, 0, 0)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.0618000000000052,0.004199999999997317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021362",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36aap13299238418077763",
    x1: -32.63994350237298,
    y1: -0.3486404230609994,
    x2: 9.120656891482648,
    y2: 48.02257314417939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(125, 188, 255)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(71, 135, 254)"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021362_fill_path",
    d: "M52.50519,10.65685c-3.11235,-1.19353 -6.51553,-0.59251 -9.25763,1.30981c-1.00194,-5.00868 -4.18539,-9.24776 -8.92593,-11.06571c-7.76771,-2.97887 -16.77385,1.67072 -20.11579,10.38512c-0.86119,2.24561 -1.26108,4.54183 -1.24895,6.76469c-0.40038,-0.251 -0.82863,-0.46636 -1.2833,-0.64075c-4.24399,-1.62755 -9.16458,0.91284 -10.99045,5.67403c-1.82588,4.76124 0.13435,9.94032 4.37834,11.56787c0.89811,0.34442 5.93946,0.79104 5.93946,0.79104c0,0 35.40004,-2.63611 36.49195,-2.62706c4.3607,0.03628 8.65861,-2.94673 10.48319,-7.70463c2.28151,-5.94927 -0.16793,-12.42071 -5.4709,-14.4544z",
    fillRule: "nonzero",
    fill: "url(#ldd36aap13299238418077763)"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,25.968300000000003,59.7879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021363",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021364",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021364_fill_path",
    d: "M1.16135,0.71872c-1.35488,1.1104 -1.55299,3.10884 -0.44264,4.46372l9.14992,11.16437l4.9063,-4.02108l-9.14992,-11.16437c-1.11035,-1.35482 -3.10879,-1.55304 -4.46367,-0.44264z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11.989799999999995,8.465400000000002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021365",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021365_fill_path",
    d: "M17.85229,2.8137c-0.19795,-1.74054 -1.76938,-2.991 -3.50986,-2.7931l-14.34243,1.63111l0.71682,6.30291l14.34237,-1.63111c1.74054,-0.1979 2.99105,-1.76927 2.79309,-3.50981z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.387499999999996,9.246200000000002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021366",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36abj8604850697943636",
    x1: 8.367319112907118,
    y1: -0.1534438754982448,
    x2: -1.911731761280377,
    y2: 12.83060216072647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(68, 75, 140)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.6399998664856%",
    stopOpacity: 1,
    stopColor: "rgb(38, 38, 79)"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021366_fill_path",
    d: "M9.20475,4.60237c0,2.54182 -2.06055,4.60237 -4.60237,4.60237c-2.54182,0 -4.60237,-2.06055 -4.60237,-4.60237c0,-2.54182 2.06055,-4.60237 4.60237,-4.60237c2.54182,0 4.60237,2.06055 4.60237,4.60237z",
    fillRule: "nonzero",
    fill: "url(#ldd36abj8604850697943636)"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,52.7989,66.7475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I361022587357021367",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ldd36aby450693441145982",
    x1: 9.196467929905834,
    y1: 5.948615514362219,
    x2: -6.734454473524755,
    y2: 1.7666077484202687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(68, 75, 140)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.6399998664856%",
    stopOpacity: 1,
    stopColor: "rgb(38, 38, 79)"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "I361022587357021367_fill_path",
    d: "M0.084,2.11406l2.36895,5.81434c0.35208,0.86415 1.68734,1.1215 2.70615,0.50802c1.49283,-0.89892 3.12441,-2.43255 2.46571,-4.65056c-0.83342,-2.80642 -3.31277,-3.61466 -5.35283,-3.7786c-1.38437,-0.11121 -2.60836,1.0751 -2.18798,2.1068z",
    fillRule: "nonzero",
    fill: "url(#ldd36aby450693441145982)"
  }))))))))))))))))))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#I361022587357021313",
    attributeName: "transform",
    type: "rotate",
    values: "0 39 39;90 39 39;180 39 39;359 39 39",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.34;0.65;1",
    keySplines: "0.2796 0.3029 0.0521 0.851;0.2796 0.3029 0.0521 0.851;0.2796 0.3029 0.0521 0.851",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#I361022587357021329",
    attributeName: "transform",
    type: "rotate",
    values: "0 22 22;-90 22 22;-180 22 22;-359 22 22",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.34;0.65;1",
    keySplines: "0.2796 0.3029 0.0521 0.851;0.2796 0.3029 0.0521 0.851;0.2796 0.3029 0.0521 0.851",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform3 || (_animateTransform3 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#I361022587360522091",
    attributeName: "transform",
    type: "translate",
    values: "0 0;0 19;-0.001300000000000523 -18.0031;-0.001300000000000523 -0.0030999999999998806",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.34;0.65;1",
    keySplines: "0.2796 0.3029 0.0521 0.851;0.2796 0.3029 0.0521 0.851;0.2796 0.3029 0.0521 0.851",
    additive: "sum",
    fill: "freeze"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiWork);
export default __webpack_public_path__ + "static/media/ai-work.57fb870923f6da2be7e02931ef11b311.svg";
export { ForwardRef as ReactComponent };